import React from "react";
import { FaPaintBrush, FaCode, FaMobileAlt } from "react-icons/fa";

function Services() {
  const services = [
    {
      title: "UI/UX Design",
      description: "Creating intuitive and engaging designs for your products.",
      icon: <FaPaintBrush className="text-4xl text-indigo-500 mb-4" />,
    },
    {
      title: "Web Development",
      description: "Building responsive and high-performance websites.",
      icon: <FaCode className="text-4xl text-indigo-500 mb-4" />,
    },
    {
      title: "App Development",
      description:
        "Developing mobile applications for both Android and iOS platforms.",
      icon: <FaMobileAlt className="text-4xl text-indigo-500 mb-4" />,
    },
  ];

  return (
    <div
      id="/services"
      className="bg-gradient-to-r from-indigo-400 to-purple-600 p-8"
    >
      <div className="container mx-auto text-center py-10">
        <h1 className="text-4xl font-bold mb-8 text-white">Our Services</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white text-gray-800 p-6 rounded-lg shadow-lg transform hover:scale-105 hover:bg-indigo-100 transition duration-300 ease-in-out flex flex-col items-center"
            >
              {service.icon}
              <h2 className="text-2xl font-bold mb-2">{service.title}</h2>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Services;
